import { LeafButton } from "./button.component.js";
customElements.define("leaf-button", LeafButton);
export {
  LeafButton
};
//# sourceMappingURL=button.js.map
